const className = 'Messages'

export default class Messages {
  constructor (Parse) {
    this.Parse = Parse
  }

  /**
   * Set site changes
   * http://parseplatform.org/Parse-SDK-JS/api/classes/Parse.Object.html#methods_save
   * @param {Object} site - Site parse object
   * @param {Object} data - Site data object
   */
  set (site, data, options = {}) {
    var Class = this.Parse.Object.extend(className)
    var object = new Class()
    object.set('data', data, {error: this.onError})
    site.set('messages', object, {error: this.onError})
    site.save(null, options)
    return object.save(null, options)
  }

  onError (object, error) {
    console.log('Error', error)
  }
}



//////////////////
// WEBPACK FOOTER
// ./parse-model/Messages.mjs
// module id = q6Kc
// module chunks = 0